var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTemplates = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Templates")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Impact/Pricing_Parameters_Collapsed",
    transform: "translate(-1122.000000, -12.000000)",
    fill: "#335498",
    stroke: "#335498",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Templates",
    transform: "translate(1123.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.54383393,2.34475343 L1.24168671,2.34475343 C0.556507255,2.34475343 -1.44773082e-13,2.8252239 -1.44773082e-13,3.41678581 L-1.44773082e-13,12.4624062 C-1.44773082e-13,13.0539681 0.556507255,13.5344386 1.24168671,13.5344386 L8.54383393,13.5344386 C9.22901338,13.5344386 9.78552063,13.0539681 9.78552063,12.4624062 L9.78552063,3.41678581 C9.78230383,2.8252239 9.22579657,2.34475343 8.54383393,2.34475343 Z M8.9137665,12.4596289 C8.9137665,12.6373752 8.74649264,12.7817941 8.54061712,12.7817941 L1.2384699,12.7817941 C1.03259439,12.7817941 0.86532053,12.6373752 0.86532053,12.4596289 L0.86532053,3.41678581 C0.86532053,3.23903951 1.03259439,3.09462064 1.2384699,3.09462064 L8.54061712,3.09462064 C8.74649264,3.09462064 8.9137665,3.23903951 8.9137665,3.41678581 L8.9137665,12.4596289 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.259656,-1.90070182e-13 L3.95750875,-1.90070182e-13 C3.27232929,-1.90070182e-13 2.71582204,0.480470472 2.71582204,1.07203238 C2.71582204,1.28032883 2.90883033,1.44696599 3.15009071,1.44696599 C3.39135108,1.44696599 3.58435937,1.28032883 3.58435937,1.07203238 C3.58435937,0.89428608 3.75163323,0.74986721 3.95750875,0.74986721 L11.259656,0.74986721 C11.4655315,0.74986721 11.6328053,0.89428608 11.6328053,1.07203238 L11.6328053,10.1176528 C11.6328053,10.2953991 11.4655315,10.4398179 11.259656,10.4398179 C11.0183956,10.4398179 10.8253873,10.6064551 10.8253873,10.8147515 C10.8253873,11.023048 11.0183956,11.1896851 11.259656,11.1896851 C11.9448354,11.1896851 12.5013427,10.7092147 12.5013427,10.1176528 L12.5013427,1.07203238 C12.5013427,0.480470472 11.9448354,-1.90070182e-13 11.259656,-1.90070182e-13 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTemplates, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Templates.8165efc6.svg";
export { ForwardRef as ReactComponent };